import React from 'react';

// PM‑editable copy separated from UI
export const incomeManagementTourCopy = {
  headerTitle: 'Income Management',
  headerBody: 'Track all your income sources and project future earnings with automatic growth calculations.',
  summaryTitle: 'Income Summary Cards',
  summaryBody: 'See your total income, diversification score, and growth projections at a glance.',
  tableTitle: 'Income Sources Table',
  tableBody: 'Manage all your income streams - salary, passive income, and more. Add growth rates and track projections.',
  chartTitle: 'Income Projection Chart',
  chartBody: 'Visualize how your income will grow over your projection horizon based on your growth assumptions.',
  surplusTitle: 'Surplus Routing',
  surplusBody: 'Automatically allocate your yearly surplus to different asset classes to stay on track with your goals.',
};

const Tip = ({ title, body }) => (
  <div>
    <div style={{ fontWeight: 600, color: 'var(--foreground, #111827)' }}>{title}</div>
    <div style={{ marginTop: 6, fontSize: 14, color: 'var(--muted-foreground, #6B7280)' }}>{body}</div>
  </div>
);

export const getIncomeManagementTourSteps = () => [
  {
    target: '[data-tour="income-header"]',
    content: <Tip title={incomeManagementTourCopy.headerTitle} body={incomeManagementTourCopy.headerBody} />,
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '[data-tour="income-summary"]',
    content: <Tip title={incomeManagementTourCopy.summaryTitle} body={incomeManagementTourCopy.summaryBody} />,
    placement: 'bottom',
  },
  {
    target: '[data-tour="income-table"]',
    content: <Tip title={incomeManagementTourCopy.tableTitle} body={incomeManagementTourCopy.tableBody} />,
    placement: 'top',
  },
  {
    target: '[data-tour="income-surplus"]',
    content: <Tip title={incomeManagementTourCopy.surplusTitle} body={incomeManagementTourCopy.surplusBody} />,
    placement: 'top',
  },
  {
    target: '[data-tour="income-chart"]',
    content: <Tip title={incomeManagementTourCopy.chartTitle} body={incomeManagementTourCopy.chartBody} />,
    placement: 'top',
  },
];
